import React from 'react';
import PersistentLayout from './src/components/PersistentLayout';

export const wrapPageElement = ({ element, props }) => {
	return <PersistentLayout {...props}>{element}</PersistentLayout>;
};
